import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconCase = props => (
  <SvgIcon {...props} viewBox="0 0 20 19">
    <path d="m8 0-2 2v2h-4c-1.1 0-2 0.9-2 2v11c0 1.1 0.9 2 2 2h16c1.1 0 2-0.9 2-2v-11c0-1.1-0.9-2-2-2h-4v-2l-2-2h-4zm0 2h4v2h-4v-2zm-6 4h16v11h-16v-11z" />
  </SvgIcon>
);

export default IconCase;



// WEBPACK FOOTER //
// ./src/components/icons/IconCase.js